import { render, staticRenderFns } from "./original_text_adoption.vue?vue&type=template&id=8dc5e9e8&scoped=true&"
import script from "./original_text_adoption.vue?vue&type=script&lang=js&"
export * from "./original_text_adoption.vue?vue&type=script&lang=js&"
import style0 from "./original_text_adoption.vue?vue&type=style&index=0&id=8dc5e9e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5e9e8",
  null
  
)

export default component.exports